import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import {
  Divider as MuiDivider,
  Grid,
  Typography,
  Card as MuiCard,
  CardContent,
  Box,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import PaymentTable from "../../components/PaymentTable";
import { useTranslation } from "react-i18next";

const Divider = styled(MuiDivider)(spacing);
const Card = styled(MuiCard)(spacing);
const HeroCard = styled(Card)`
  overflow: hidden;
  border-radius: 24px;
  background: linear-gradient(135deg, #10213a 0%, #1d4e89 55%, #5fa8d3 100%);
  color: #fff;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.18);
`;

const HeroKicker = styled(Typography)`
  opacity: 0.78;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-size: 0.72rem;
  font-weight: 700;
`;

const HeroTitle = styled(Typography)`
  font-weight: 800;
  margin-top: 8px;
`;

const HeroDescription = styled(Typography)`
  max-width: 640px;
  opacity: 0.88;
`;

const MetricPill = styled(Box)`
  padding: 12px 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.16);
  min-width: 180px;
`;

const SurfaceCard = styled(Card)`
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.18);
`;

function Payments() {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <Helmet title={t("payments.title")} />
      <HeroCard mb={6}>
        <CardContent>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={8}>
              <HeroKicker variant="body2">
                {t("payments.monetization")}
              </HeroKicker>
              <HeroTitle variant="h2">{t("payments.history")}</HeroTitle>
              <HeroDescription variant="body1">
                {t("payments.description")}
              </HeroDescription>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container spacing={3} justifyContent="flex-end">
                <Grid item>
                  <MetricPill>
                    <Typography variant="caption">
                      {t("payments.tracking")}
                    </Typography>
                    <Typography variant="h5">
                      {t("payments.days360")}
                    </Typography>
                  </MetricPill>
                </Grid>
                <Grid item>
                  <MetricPill>
                    <Typography variant="caption">
                      {t("payments.view")}
                    </Typography>
                    <Typography variant="h5">
                      {t("payments.detailed")}
                    </Typography>
                  </MetricPill>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </HeroCard>

      <SurfaceCard mb={6}>
        <CardContent>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={7}>
              <Typography variant="h4" gutterBottom>
                {t("payments.recentMovements")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("payments.recentDescription")}
              </Typography>
            </Grid>
          </Grid>

          <Divider my={5} />

          <Grid justify="center" container spacing={6}>
            <Grid item xs={12}>
              <PaymentTable />
            </Grid>
          </Grid>
        </CardContent>
      </SurfaceCard>
    </React.Fragment>
  );
}

export default Payments;
